// @flow
import { VisaProfiles } from '@ta/cpm.profile-sponsorship-pixels';

const trackedProfiles: Set<string> = new Set([...VisaProfiles, 'FlyScootAU', 'SeeAustralia']);
export default trackedProfiles;
